import React from 'react';
import { node } from 'prop-types';
import { BodyText } from '../../../ui';

export default function Label({ children }) {
  return (
    <BodyText
      appearance="smaller"
      weight="bold"
      style={{
        whiteSpace: 'nowrap',
        textTransform: 'uppercase',
      }}
    >
      {children}
    </BodyText>
  );
}

Label.propTypes = {
  children: node,
};

Label.defaultProps = {
  children: null,
};
